<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <table class="detail-table">
      <tbody>
        <tr>
          <td class="label-col">进度分享记录</td>
          <td>
            <template v-for="(item, index) in fullNode.project_node.node_result.share_meeting_list">
              <div :key="index" class="record-item">
                <el-tag type="">第 {{ item.seq_no }} 次</el-tag>
                <span>
                  <i class="el-icon-time"></i>
                  {{ item.share_meeting_time }}丨填写人: {{ item.submit_admin_name }}
                </span>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'

export default {
  components: {HistoryLogCom},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {
      node: {
        node_result: {}
      },
    }
  },
  created () {},
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.record-item {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}
.detail-table {
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  table-layout: fixed;
}
.detail-table td {
  padding: 12px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
}
.detail-table .label-col {
  width: 100px;
  background-color: #fafafa;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/ProgressShareMeetingView.vue